import React, { Component, Fragment } from "react";
import Index from "../../Components/ProducaoSTI/Realizado/Relatorio1/Index";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Navbar from "../../Components/ProducaoSTI/Realizado/UI/Navbar";

export default class PageRelatorio extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
    }

    componentDidMount() {
    }

    render() {
        return (
            <Fragment>

                <div className="row mb-4">
                    <Navbar />
                </div>

                <div className="container mt-4 mb-5">
                
                    <div className="card text-center">
                        <div className="card-header pb-4">
                        </div>
                        <div className="card-body">
                            <h5 className="card-title">Produção STI SENAI</h5>
                            <p className="card-text">Relatório da produção de STI do SENAI</p>
                            <a href="/sti/producaosti/relatorio1" className="btn btn-primary me-2">Realizado</a>
                            <a href="/sti/producaosti/relatorio4" className="btn btn-primary me-2">Metas</a>
                            <a href="/sti/producaosti/relatorio3" className="btn btn-primary me-2">Metas/Realizado</a>
                            <a href="/sti/producaosti/relatorio2" className="btn btn-primary me-2">Dinâmico</a>
                        </div>
                    </div>

                </div>

            </Fragment>
        )
    }
}